export enum DocumentUploadModalMode {
  ADD = "ADD",
  EDIT = "EDIT",
  ADD_LOMN = "ADD_LOMN",
  ADD_LAB_RESULTS = "ADD_LAB_RESULTS",
  ADD_DENIAL_LETTER = "ADD_DENIAL_LETTER",
}

export enum DocumentUploadModalNavigationDirection {
  BACK = "BACK",
  CLOSE = "CLOSE",
}
